<template>
    <div class="subsequent-cards">
        <h3 class="mb-4 mt-4 pb-2 w-100 text-center color--blue-7">
            {{ title }}
        </h3>

        <div ref="sliderInside" class="activities-inside__slider row">
            <activity-card
                v-for="activity in activities"
                :key="activity.id"
                class="mb-2 col-12 col-sm-6 col-md-3"
                :activity="activity"
            ></activity-card>
        </div>
    </div>
</template>
<script>
import activityCard from '@/components/cards/activity-card';

export default {
    components: {
        activityCard
    },
    props: {
        activities: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default: null
        }
    }
};
</script>
<style></style>
